import { render, staticRenderFns } from "./QuinielaAdmin.vue?vue&type=template&id=d9281c9a&lang=pug"
import script from "./QuinielaAdmin.vue?vue&type=script&lang=js"
export * from "./QuinielaAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports